import { jsx as _jsx } from "react/jsx-runtime";
// ~/avaai_dashboard/frontend/src/context/PreferencesContext.tsx
import { createContext, useContext, useEffect, useState, } from "react";
import { getInitialPreferredLanguage, persistPreferredLanguage, } from "../utils/avaaioLanguage";
const PreferencesContext = createContext(undefined);
export const PreferencesProvider = ({ children }) => {
    const [preferences, setPreferences] = useState({
        theme: "dark",
        accentColor: "#0ff",
        language: getInitialPreferredLanguage(),
    });
    useEffect(() => {
        persistPreferredLanguage(preferences.language || "en");
    }, [preferences.language]);
    useEffect(() => {
        function handleLanguageUpdate(incomingEvent) {
            const event = incomingEvent;
            const language = event.detail?.language;
            if (!language) {
                return;
            }
            setPreferences((current) => {
                if (current.language === language) {
                    return current;
                }
                return {
                    ...current,
                    language,
                };
            });
        }
        window.addEventListener("avaaio-language-updated", handleLanguageUpdate);
        return () => {
            window.removeEventListener("avaaio-language-updated", handleLanguageUpdate);
        };
    }, []);
    return (_jsx(PreferencesContext.Provider, { value: {
            preferences,
            setPreferences,
        }, children: children }));
};
export const usePreferences = () => {
    const context = useContext(PreferencesContext);
    if (!context) {
        throw new Error("usePreferences must be used within PreferencesProvider");
    }
    return context;
};
